// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__2SsSb","contactinfo":"Contact_contactinfo__2Qg5d"};